__webpack_require__.p = "/desain-interaksi-software-tools-pengelolaan-basis-data/";